import { Fragment, useState } from 'react';
import { useSelector } from 'react-redux'
import { useParams } from "react-router-dom";


import local from './local/pass_recovery_localisation'

var msg = null;

export default function Passrecovery(){

    const [AllIs, setAllIs] = useState({done:false, error:null, open:true});
    const [msg, setMsg] = useState('ok');
    const setup = useSelector(state => state.site.setup);
    

    
    let { base, id } = useParams();

    let LANG = setup.lang;

const open = () => setAllIs({loading:false, error:null, open:true}) 
const toggle = () => AllIs.open ? setAllIs({...AllIs, open:false}) : setAllIs({...AllIs, open:true})


if(AllIs.error){
    return (
        <Fragment>
            <Fragment>
                <div className="login" onClick={toggle}>ASK QST: {AllIs.error.message}</div>
            </Fragment>
        </Fragment>
    )
} 

if(AllIs.done){
    return(  
    <Fragment>
            <p>
                {local[LANG].msg}{document.forms.login.email.value}
           </p>
    </Fragment>
)
}

localStorage.clear();

return(
<Fragment>
    <Fragment>
        <form name="login" onSubmit={(ev)=>{SaveDATA(ev)}} className="login pt10">
        { msg !=='ok' ? <p>{msg}</p> : null}
        <h2>{local[LANG].fttl}</h2>
        <input required type="email" name="email" placeholder={local[LANG].email}/>
        <br/>
        <button type="submit" className="btn submit w50">{local[LANG].submit}</button>
        </form>
    </Fragment>
</Fragment>
 )   

 function SaveDATA(ev){
    ev.preventDefault()
    var sndForm = document.forms.login;

    const form = new FormData()
          form.append('lang', setup.lang);
          form.append('mail', sndForm.elements.email.value);
          //form.append('txt', sndForm.elements.text.value);
    const MyInit = { 
                method: 'POST',
                body: form
                };
  fetch(setup.domen+setup.folder+'passrecovery', MyInit)
    .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.text()+'Something went wrong ...');
        }
    })
    .then(data => {
        let msg = data.resp;
        if(msg ==='ok'){
            setAllIs({...AllIs, done:true});
        } else {
            setMsg(msg);
        }
        
    })
    .catch(error => {
        setAllIs({...AllIs, error:error});
    });
  }


} //************ */